import {observer} from 'mobx-react-lite'
import React, {useCallback} from 'react'
import {newsCompanyId} from 'yougile-model'
import {cn} from '@containers/html-utils'
import {globals} from '@extensions/globals-base'
import {TwEditorContainer} from './containers'
import {useTaskDescription} from './task-description-store'

type Props = {
  children: JSX.Element
  editorContainerRef: React.MutableRefObject<HTMLDivElement>
}

export const EditorContainer = observer((props: Props) => {
  const [state, store] = useTaskDescription()

  const onKeyDown = useCallback((e: React.KeyboardEvent) => {
    if (e.code === 'PageUp' || e.code === 'PageDown') {
      e.preventDefault()
    }

    if (e.code === 'Escape') {
      store.onEscape() && e.stopPropagation()
    }
  }, [])

  const readonly = !state.edit

  const hub = store.taskHub
  const isNews = hub && hub.companyId === newsCompanyId

  const isDark = globals.theme === 'dark'
  const editorCls = cn(
    isDark && 'dark-theme',
    true && 'fullscreen',
    readonly && 'readonly',
    !readonly && 'editable',
    isNews && 'news'
  )

  const editorStyle: React.CSSProperties = {}
  const {children, editorContainerRef} = props

  return (
    <TwEditorContainer
      ref={editorContainerRef}
      className={editorCls}
      style={editorStyle}
      onKeyDown={onKeyDown}
    >
      {children}
    </TwEditorContainer>
  )
})
